(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["div-ordi-choix-board"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', (event) => {
    setTimeout(() => {
        var style = document.createElement('style');
        style.type = 'text/css';
        style.innerHTML = '.form.needsclick.klaviyo-form.klaviyo-form-version-cid_2.kl-private-reset-css-Xuajs1 { max-width: 800px !important; }';
        document.head.appendChild(style);
    }, 100); // 100 milliseconds = 0.1 second
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow-lec"] && !Shopify.designMode) return;
  try {
    
function adjustFontSizeAndSpacing(divClass, textClass) {
  var divs = document.getElementsByClassName(divClass);
  var texts = document.getElementsByClassName(textClass);

  for (var i = 0; i < divs.length; i++) {
      var div = divs[i];
      var text = texts[i];
      var divWidth = div.offsetWidth;

      var fontSize = 10; // taille de départ
      text.style.fontSize = fontSize + 'px';

      while (text.scrollWidth <= divWidth && fontSize < 150) { // max font size
          fontSize++;
          text.style.fontSize = fontSize + 'px';
      }

      // Quand le texte dépasse la largeur de la div, réduire la taille de la police
      if (text.scrollWidth > divWidth) {
          fontSize--;
          text.style.fontSize = fontSize + 'px';
      }

      // Si la taille maximale de la police a été atteinte, augmenter l'espacement des lettres
      if (fontSize >= 150) {
          var letterSpacing = 0; // espacement de départ
          text.style.letterSpacing = letterSpacing + 'px';

          while (text.scrollWidth <= divWidth) {
              letterSpacing++;
              text.style.letterSpacing = letterSpacing + 'px';
          }

          // Quand le texte dépasse la largeur de la div, réduire l'espacement des lettres
          if (text.scrollWidth > divWidth) {
              letterSpacing--;
              text.style.letterSpacing = letterSpacing + 'px';
          }
      }
  }
}

window.onload = function () {
  adjustFontSizeAndSpacing('myDiv', 'titre');
};

window.onresize = function () {
  adjustFontSizeAndSpacing('myDiv', 'titre');
};

  } catch(e) { console.error(e); }
})();
})();
